<div class="header-bar">
  <div class="text-center mx-auto">
    <img [src]="sellerDetails?.evaluationLogoUrl || sellerDetails?.logoUrl || './assets/images/logo-aar-horizontal-branco-ciano.png'" class="logo-img" />
  </div>
</div>